import Index from "@/pages/Index";
import Home from "@/pages/Home";

export const routes = [{
  path: "/",
  name: "Index",
  component: Index,
  redirect: {
    name: 'Home'
  },
  children: [{
      path: "/home",
      name: "Home",
      component: Home
    },
    {
      path: "/introduction",
      name: "Introduction",
      component: () => import("@/pages/Introduction"),
    },
    {
      path: "/booth-area-list",
      name: "BoothList",
      component: () => import("@/pages/Booth/Booth"),
    },
    {
      path: "/booth-area-all",
      name: "BoothAllArea",
      component: () => import("@/pages/Booth/BoothAllArea"),
    },
    {
      path: "/booth-area-detail",
      name: "BoothAreaDetail",
      component: () => import("@/pages/Booth/BoothAreaDetail"),
    },
    {
      path: "/forum-sign",
      name: "ForumSign",
      component: () => import("@/pages/ForumSign"),
    },
    {
      path: "/activity-time",
      name: "ActivityTime",
      component: () => import("@/pages/activityTime"),
    },
    {
      path: "/booth-map",
      name: "BoothMap",
      component: () => import("@/pages/BoothMap"),
    },
    {
      path: "/clause",
      name: "Clause",
      component: () => import("@/pages/Declaration/Clause"),
    },
    {
      path: "/privacy",
      name: "Privacy",
      component: () => import("@/pages/Declaration/Privacy"),
    },
  ],

}, {
  path: '*',
  redirect: {
    name: 'Home'
  },
}];